
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/buero/team",
      function () {
        return require("private-next-pages/buero/team/index.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/buero/team"])
      });
    }
  